import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, trackCheckout } from '../data/offer';
const highlights = ['Complete 6-in-1 System', '5 Strategic Bonuses', 'Full Access Today'];
export function Hero() {
  return <section className="relative pt-8 sm:pt-12 pb-14 px-4 overflow-hidden bg-carbon" data-id="element-166" data-mp="4mrul1r1q1lr">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-carbon-card via-carbon to-carbon -z-0" data-id="element-167" data-mp="12a0it4iflorg" />
      <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-168" data-mp="xb5whsl99i2l">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-169" data-mp="s9gfzxf9kc74">
          <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full border border-gold/50 text-gold font-semibold text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-170" data-mp="3czfkty10i55i">
            🥋 Brazilian Jiu Jitsu Coach Ready
          </div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6 sm:mb-8 text-white" data-id="element-171" data-mp="3o6kg9kdpcg66">
            Solve an entire year of BJJ classes{' '}
            <span className="text-gold" data-id="element-172" data-mp="3e8wielksusjs">in just 5 minutes</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-6 sm:mb-8" data-id="element-173" data-mp="30hhovkt9n8yh">
          <img src="https://cdn.magicpatterns.com/uploads/vwZpZsJZXgaTdK2NxBPBCr/Diseno_sin_titulo_(72).png" alt="Brazilian Jiu Jitsu Coach Ready — The complete 6-in-1 coaching system box set" className="w-full h-auto drop-shadow-[0_30px_60px_rgba(0,0,0,0.7)]" data-id="element-174" data-mp="2violwmblv0ck" />
        </motion.div>

        <div className="w-full" data-id="element-175" data-mp="s334ncg7smx0">
          <p className="text-sm sm:text-lg md:text-xl text-mist leading-snug max-w-3xl mx-auto mb-6 sm:mb-8" data-id="element-176" data-mp="s3co0h6r7vtq">
            <span className="font-semibold text-gold" data-id="element-177" data-mp="n9i4bdr5fgun">BJJ Coach Ready</span> —
            100 complete ready-to-teach Brazilian Jiu Jitsu lessons, 4 volumes
            and 5 strategic bonuses
          </p>
          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-178" data-mp="dbaq32o8vcwc">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-6 sm:px-10 whitespace-nowrap" data-id="element-179" data-mp="1b0drtyoknpw3">
              {ctaLabel}
            </Button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-smoke" data-id="element-180" data-mp="x0l48c8cdpsc">
            {highlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-181" data-mp="3hrlk4hb3w58g">
                <CheckIcon size={14} className="text-gold" data-id="element-182" data-mp="3htpzpwidasok" />
                <span data-id="element-183" data-mp="1xam5wruslszg">{highlight}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}